var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJokerPlusLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 28,
    viewBox: "0 0 112 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7914 21.9275H0V25.976H17.1168V11.7896H12.7236L12.7914 21.9275Z",
    fill: "url(#paint0_linear_3256_16036)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1968 15.8436H31.6658V21.9275H22.7562V15.8436H26.7057V11.7896H18.3691V25.976H36.1206V11.7896H28.1968V15.8436Z",
    fill: "url(#paint1_linear_3256_16036)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2559 11.7896V25.9199H42.6429V19.1239V11.7896H38.2559Z",
    fill: "url(#paint2_linear_3256_16036)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4565 11.7896H51.8723L42.6484 19.1239L52.4022 28.0002H57.8983L48.2739 19.236L56.4565 11.7896Z",
    fill: "url(#paint3_linear_3256_16036)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5141 21.8677H57.8242V25.9217H75.5141V21.8677Z",
    fill: "url(#paint4_linear_3256_16036)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8242 20.8846H75.5141V16.8305H62.5501V15.8436H75.5141V11.7896H57.8242V20.8846Z",
    fill: "url(#paint5_linear_3256_16036)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8643 22.9144H95.0498V11.7896H77.3477V15.8436H90.595V18.7931H81.8209L91.8889 27.961H97.4097L91.8643 22.9144Z",
    fill: "url(#paint6_linear_3256_16036)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4935 3.07666V8.54377H59.9746V9.99606H57.8365V6.4971H64.2877V5.05603H57.8242V3.07666H66.4874H66.4935Z",
    fill: "#FFF4E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9972 8.02229V9.96802H67.5312V3.07666H69.7371V8.01669H75.9972V8.02229Z",
    fill: "#FFF4E0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2468 8.02229V9.99606H76.5898V3.07666H78.7957V8.01668H85.2468V8.02229ZM85.2468 3.08226V7.4896L83.041 7.47278V3.08226H85.2468Z",
    fill: "#FFF4E0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0421 3.07666V5.05603H88.5539V7.52885H86.3789V3.08226H95.0359L95.0421 3.07666ZM89.0715 5.57751H95.0421V9.99606H86.3851V8.02229H92.8732V7.52885H89.0715V5.58312V5.57751Z",
    fill: "#FFF4E0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106.677 6.16573H104.749V4.41064H103.276V6.16573H101.348V7.51149H103.276V9.26656H104.749V7.51149H106.677V6.16573Z",
    fill: "#5F5F5F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M109.988 7.12687L104.239 12.3585C104.091 12.4931 103.851 12.4931 103.709 12.3585L97.9606 7.12687C97.8127 6.9923 97.8127 6.77361 97.9606 6.64464L103.709 1.41304C103.857 1.27846 104.098 1.27846 104.239 1.41304L109.988 6.64464C110.136 6.77922 110.136 6.9979 109.988 7.12687ZM96.6359 7.36798L103.444 13.564C103.74 13.8332 104.215 13.8332 104.51 13.564L111.319 7.36798C111.615 7.09883 111.615 6.66707 111.319 6.39792L104.51 0.201863C104.215 -0.0672875 103.74 -0.0672875 103.444 0.201863L96.6359 6.39792C96.3401 6.66707 96.3401 7.09883 96.6359 7.36798Z",
    fill: "#5F5F5F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3256_16036",
    x1: -0.992011,
    y1: 18.8828,
    x2: 93.5941,
    y2: 18.8828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3256_16036",
    x1: -0.99048,
    y1: 18.8828,
    x2: 93.5956,
    y2: 18.8828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3256_16036",
    x1: -0.99944,
    y1: 18.8547,
    x2: 93.5867,
    y2: 18.8547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3256_16036",
    x1: -0.993884,
    y1: 19.8921,
    x2: 93.5922,
    y2: 19.8921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3256_16036",
    x1: -0.994036,
    y1: 23.8919,
    x2: 93.5921,
    y2: 23.8919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3256_16036",
    x1: -0.994036,
    y1: 16.3371,
    x2: 93.5921,
    y2: 16.3371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3256_16036",
    x1: -0.990393,
    y1: 19.8753,
    x2: 93.5957,
    y2: 19.8753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJokerPlusLogo);
export default __webpack_public_path__ + "static/media/joker-plus-logo.7b8c9812cb603c8fb27321a6cd7f1b2c.svg";
export { ForwardRef as ReactComponent };